import { camelizeKeys, decamelizeKeys } from 'humps'
import { getCredentials } from 'shared/infrastructure/storage'

const requestInterceptor = request => {
  if (request.headers['Content-Type'].includes('application/json')) {
    request.data = decamelizeKeys(request.data)
  }
  request.headers.Authorization = `Bearer ${getCredentials()}`
  return request
}

const responseInterceptor = response => {
  if (
    response.data &&
    response.headers['content-type'].includes('application/json')
  ) {
    response.data = camelizeKeys(response.data)
  }

  return response
}

export { requestInterceptor, responseInterceptor }
